import React from 'react';
import {Stack, styled} from '@mui/material';
import {
  Body,
  Button,
  designSystemToken,
  Headline,
  Icon,
} from '@lightricks/react-design-system';
import {
  FreeTrialEndModalReason,
  FreeTrialEndModalReasonKeys,
} from '@contentlab/stores/freeTrialEndModalStore';
import translate from '@/utils/translate';

const IconWithBackground = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{
  bgColor?: string;
}>(({bgColor}) => ({
  backgroundColor: bgColor,
  borderRadius: '999px',
  padding: '4px',
}));

type FreeTrialEndModalContentProps = {
  onBackToEditor: () => void;
  onStartProSubscription: () => void;
  reason: FreeTrialEndModalReasonKeys | null;
  isLoading?: boolean;
};

const getTitle = (reason: FreeTrialEndModalReasonKeys | null) => {
  const reasonMap: Record<FreeTrialEndModalReasonKeys, string> = {
    [FreeTrialEndModalReason.UPGRADE]: translate(
      'Unlock Your Full Subscription'
    ),
    [FreeTrialEndModalReason.CREDIT_END]: translate(
      "You're All Out of Free Trial Credits"
    ),
  };
  return (
    reasonMap[reason as FreeTrialEndModalReasonKeys] ||
    reasonMap[FreeTrialEndModalReason.UPGRADE]
  );
};

function FreeTrialEndModalContent({
  onBackToEditor,
  onStartProSubscription,
  reason,
  isLoading,
}: FreeTrialEndModalContentProps) {
  return (
    <Stack>
      <Stack
        direction="row"
        gap="8px"
        alignItems="center"
        justifyContent="center"
        marginBottom="8px"
      >
        <IconWithBackground
          name="Features-Flash-Fill"
          size="medium"
          appearance="brand"
          bgColor={designSystemToken('semantic.bg.brand-secondary')}
        />
      </Stack>
      <Headline size="md" marginBottom="16px" textAlign="center">
        {getTitle(reason)}
      </Headline>
      <Body
        size="lg"
        marginBottom="16px"
        textAlign="center"
        color={designSystemToken('semantic.fg.secondary')}
      >
        {translate(
          'Talk to sales to continue with LTX Scaler and keep scaling your content.'
        )}
      </Body>
      <Stack direction="row" gap="12px" justifyContent="center">
        <Button
          appearance="neutral"
          mode="tinted"
          size="large"
          onClick={onBackToEditor}
        >
          {translate('Back')}
        </Button>
        <Button
          appearance="neutral"
          mode="filled"
          size="large"
          onClick={onStartProSubscription}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {translate('Contact Sales')}
        </Button>
      </Stack>
    </Stack>
  );
}

export default FreeTrialEndModalContent;
